import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext, getClonedData } from 'commons-ui';

import { FORM_FIELD_KEYS } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { IHappyHourTemplate } from '../../interfaces';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const data = _get(location, ['state', 'rowData']);
	const { requestCreateHappyHour } = useService();

	const cloneHappyHour = (clonedData: { happyHourData: IHappyHourTemplate }) => {
		setShowLoader(true);
		const { happyHourData } = clonedData;
		requestCreateHappyHour(app.appName, { ...happyHourData }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating happy hour template', { type: 'error' });
					setShowLoader(false);
					return;
				}
				showAlert('Happy hour template created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: IHappyHourTemplate) => {
		cloneHappyHour(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: getClonedData(data, FORM_FIELD_KEYS),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
